import React, { useContext, useState, useEffect } from "react";
import { get, cloneDeep, set } from "lodash";
import { Input, Label } from "reactstrap";
import ReactDragListView from "react-drag-listview";

import { InvoiceTemplateContext } from "../InvoiceTemplateContext";
import Slider from "react-rangeslider";
import AddCustomFieldPopup from "./AddCustomFieldPopup";

const InvoiceTemplateDetailEditor = () => {
  const { state, dispatch } = useContext(InvoiceTemplateContext);
  const [invoiceData, setInvoiceData] = useState(() => {
    return cloneDeep(state?.invoiceData);
  });
  const { selectedSection: selectedSectionName } = cloneDeep(state);
  const [isOpenCustomFieldPopup, setIsOpenCustomFieldPopup] = useState(false);
  const [fields, setFields] = useState([]);
  const [selectedSection, setSelectedSection] = useState();

  const [selectedField, setSelectedField] = useState(null);
  const [selectedFieldIndex, setSelectedFieldIndex] = useState(-1);
  const [selectedFieldWidth, setSelectedFieldWidth] = useState(0);

  const updateInvoiceData = (key, value) => {
    dispatch({
      type: "updateInvoiceData",
      payload: { path: `${selectedSectionName}.fields${key}`, value },
    });
    set(fields, key, value);
    setFields(fields);
  };

  useEffect(() => {
    setInvoiceData(cloneDeep(state?.invoiceData));
  }, [state]);

  const updateInvoiceDataDnD = value => {
    dispatch({
      type: "updateInvoiceDataDnD",
      payload: { path: `${selectedSectionName}.fields`, value },
    });
  };

  useEffect(() => {
    setFields([]);
    if (selectedSectionName) {
      setSelectedSection(get(invoiceData, `${selectedSectionName}`));
      if (fields && selectedSectionName === "invoiceSection") {
        const data = get(invoiceData, `${selectedSectionName}.fields`);
        data.push(get(invoiceData, `${selectedSectionName}.dateTime`));
        data.push(get(invoiceData, `${selectedSectionName}.serialNo`));
        data.push(get(invoiceData, `${selectedSectionName}.no`));
        setFields(data);
      } else {
        const data = get(invoiceData, `${selectedSectionName}.fields`);
        setFields(data);
      }
    }
  }, [selectedSectionName, invoiceData]);

  useEffect(() => {
    setSelectedField(null);
  }, [selectedSectionName]);

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      const data = [...fields];
      const item = data.splice(fromIndex, 1)[0];
      data.splice(toIndex, 0, item);
      data.forEach((d, index) => {
        d.order = index + 1;
      });
      updateInvoiceDataDnD(data);
      setFields(data);
    },
    nodeSelector: ".draggable-element",
    handleSelector: "i",
  };

  const addField = () => {
    if (!selectedSection || !selectedSection?.canAddCustomField) {
      return;
    }
    setIsOpenCustomFieldPopup(true);
  };

  const handleClose = () => {
    setIsOpenCustomFieldPopup(!isOpenCustomFieldPopup);
  };

  useEffect(() => {
    if (selectedField && selectedField.style) {
      const widthStyle = selectedField.style.width;
      const width = widthStyle.substring(0, widthStyle.indexOf("%"));
      setSelectedFieldWidth(parseInt(width, 10));
    }
  }, [selectedField]);

  return (
    <div className="container-fluid">
      <AddCustomFieldPopup
        isOpen={isOpenCustomFieldPopup}
        toggleModal={() => handleClose()}
      />
      <div className="row">
        {fields && fields.length > 0 ? (
          <>
            <div className="col-12">
              {selectedSection?.canAddCustomField && (
                <div className="text-right">
                  <button
                    className="btn btn-outline-primary"
                    onClick={() => addField()}
                  >
                    <i className="bx bx-plus font-size-16 align-middle" /> Thêm
                  </button>
                </div>
              )}

              {selectedField && (
                <div className="my-3">
                  <div className="row align-items-center">
                    <Label className="col-3">Độ rộng</Label>
                    <div className="col-9">
                      <Slider
                        orientation="horizontal"
                        min={0}
                        max={100}
                        value={selectedFieldWidth}
                        onChange={value => {
                          updateInvoiceData(`[${selectedFieldIndex}].style`, {
                            width: `${value}%`,
                          });
                          setSelectedFieldWidth(value);
                        }}
                      />
                    </div>
                  </div>
                  <hr />
                </div>
              )}
            </div>

            <ReactDragListView {...dragProps}>
              <div>
                {fields
                  .sort((a, b) => a.order - b.order)
                  .map((field, index) => (
                    <div
                      key={selectedSection + index}
                      className="col-12 draggable-element"
                    >
                      {field.label && (
                        <div
                          onClick={() => {
                            setSelectedField(field);
                            setSelectedFieldIndex(index);
                          }}
                          className="d-flex align-items-center py-2 border-b"
                        >
                          <div className="form-check">
                            <Input
                              style={{ cursor: "pointer" }}
                              type="checkbox"
                              className="form-check-Input"
                              disabled={!field.canHide}
                              checked={field.visible}
                              onChange={event => {
                                updateInvoiceData(
                                  `[${index}].visible`,
                                  event.target.checked
                                );
                              }}
                            />
                          </div>
                          <div className="d-flex flex-grow-1">
                            <div className="flex-grow-1">
                              <Input
                                type="text"
                                className="form-control"
                                readOnly={!field.editable}
                                value={field.label.vi}
                                onChange={event => {
                                  updateInvoiceData(
                                    `[${index}].label.vi`,
                                    event.target.value
                                  );
                                }}
                              />
                            </div>
                            <div className="ms-2 flex-grow-1">
                              <Input
                                type="text"
                                className="form-control"
                                readOnly={!field.editable}
                                value={field.label.en}
                                onChange={event => {
                                  updateInvoiceData(
                                    `[${index}].label.en`,
                                    event.target.value
                                  );
                                }}
                              />
                            </div>

                            {field.hasValue && (
                              <div className="ms-2 flex-grow-1">
                                <Input
                                  type="text"
                                  className="form-control"
                                  readOnly={!field.editable}
                                  value={field.value || ""}
                                  onChange={event => {
                                    updateInvoiceData(
                                      `[${index}].value`,
                                      event.target.value
                                    );
                                  }}
                                />
                              </div>
                            )}
                          </div>
                          {field.arrangeable && (
                            <i
                              className="bx bx-menu bx-sm text-primary ms-2"
                              style={{ cursor: "move" }}
                            />
                          )}
                        </div>
                      )}

                      {field.labels && field.labels.length > 0 && (
                        <div className="w-100">
                          {field.labels.map((labelItem, labelIndex) => (
                            <div
                              key={labelIndex}
                              className="d-flex align-items-center py-2 border-b"
                            >
                              <div className="form-check">
                                <Input
                                  type="checkbox"
                                  className="form-check-Input"
                                  disabled={!labelItem.canHide}
                                  checked={labelItem.visible}
                                  onChange={event => {
                                    updateInvoiceData(
                                      `[${index}].labels[${labelIndex}].visible`,
                                      event.target.checked
                                    );
                                  }}
                                />
                              </div>

                              <div className="d-flex flex-grow-1">
                                <div className="flex-grow-1">
                                  <Input
                                    type="text"
                                    className="form-control"
                                    readOnly={!labelItem.editable}
                                    value={labelItem.label.vi}
                                    onChange={event => {
                                      updateInvoiceData(
                                        `[${index}].labels[${labelIndex}].label.vi`,
                                        event.target.value
                                      );
                                    }}
                                  />
                                </div>
                                <div className="ms-2 flex-grow-1">
                                  <Input
                                    type="text"
                                    className="form-control"
                                    readOnly={!labelItem.editable}
                                    value={labelItem.label.en}
                                    onChange={event => {
                                      updateInvoiceData(
                                        `[${index}].labels[${labelIndex}].label.en`,
                                        event.target.value
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                              {field.arrangeable && (
                                <i
                                  className="bx bx-menu bx-sm text-primary ms-2"
                                  style={{ cursor: "move" }}
                                />
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
              </div>
            </ReactDragListView>
          </>
        ) : (
          <div className="col-12">
            <div className="px-3 py-4 m-3 rounded border border-2 border-info">
              Kích chọn vào một trong các nhóm thông tin trên hóa đơn để thực
              hiện chỉnh sửa nội dung
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InvoiceTemplateDetailEditor;
